import { render } from "./add-Interface.vue?vue&type=template&id=c3fc0de0&scoped=true"
import script from "./add-Interface.vue?vue&type=script&lang=js"
export * from "./add-Interface.vue?vue&type=script&lang=js"

import "./add-Interface.vue?vue&type=style&index=0&id=c3fc0de0&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3fc0de0"]])

export default __exports__